import React from "react";

import Entity from "../../components/Entity";

function Representative() {
  return (
    <Entity
      title={(e) => e.firstName && e.lastName ? `${e.firstName} ${e.lastName}` : "New Representative"}
      formShema={{
        fields: [
          { name: "Last Name",   propertyName: "lastName",     type: "input",  col: 6 },
          { name: "First Name",  propertyName: "firstName",    type: "input",  col: 6 },
          { name: "Territories", propertyName: "territories",  type: "select", optionsFromServer: "territories", isMulti: true, col: 12 },
          { name: "Username",    propertyName: "userName",     type: "input",  col: 4 },
          { name: "Password",    propertyName: "password",     type: "input",  col: 4 },
          { name: "Email",       propertyName: "emailAddress", type: "input",  col: 4 },
        ],
      }}
    />
  );
}

export default Representative;
